<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2 v-if="this.user"><v-icon large class="mr-2">mdi-tooltip-account</v-icon>{{ this.user.login }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          color="primary"
          @click="updatepassword"
        >
          {{ $t('administration.user.updatemypassword')}}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="update"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="this.user">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('global.createdat') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ formatDateTime(this.user.dateCreation, 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>


        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.user.lastlogin') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ formatDateTime(this.user.lastLogin, 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.user.login') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ this.user.login }}</span>
            </v-col>
          </v-row>

        </v-col>


        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.user.email') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ this.user.email }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.user.firstname') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ this.user.firstname }}</span>
            </v-col>
          </v-row>
        </v-col>


        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.user.lastname') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ this.user.lastname }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('administration.profil.profil') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-4">{{ this.user.profil.name }}</span>
            </v-col>
          </v-row>
        </v-col>


      </v-row>


    </div>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState,mapGetters } from 'vuex';
import { formatDateTime } from '../../utils/dates';

export default {
  name: 'Profil',
  data: () => ({
    userProfil: null
  }),
  methods: {
    formatDateTime,
    ...mapActions({
      userGetData: 'user/data'
    }),
    update() {
      this.$router.push({ name: `UpdateMyProfil` });
    },
    updatepassword() {
      this.$router.push({ name: `UpdateMyPassword` });
    },
  },
  computed: {
    ...mapState('user', {
      updatedata: 'updatedata',
    }),
    ...mapGetters('user',{
      dataUser: 'data',
    }),
    user: {
      get() { return this.userProfil },
       set(value) { this.userProfil = value; }
    }
  },
  mounted() {
    this.userGetData({data: 'profil'});
    /*
    if (! this.dataUser('profil')) {
      this.userGetData({data: 'profil'});
    } else {
      this.usercustomer = this.dataUser('profil');
    }
    */
 },
  watch: {
    updatedata: function (updatedata) {
      if (updatedata == 'profil') {
        this.user = this.dataUser('profil');
      }
    },



  }
};
</script>
